import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: {
      isSelected?: boolean
    }
  ) => ({
    choice: {
      cursor: 'pointer',
      width: '100%',
      padding: 16,
      borderRadius: 8,
      transition: 'background-color 0.3s'
    },
    itemWrapper: {
      minWidth: 510
    },
    choiceText: {
      paddingLeft: 8
    },
    questionTitle: {
      textAlign: 'left'
    },
    customCheckbox: {
      '.ant-checkbox-checked .ant-checkbox-inner': {
        backgroundColor: `${props?.isSelected ? token.colorWhite : token.colorPrimary} !important`,
        borderColor: `${props?.isSelected ? 'transparent' : token.lightGrey.lightGrey3} !important`
      },
      '.ant-checkbox-checked .ant-checkbox-inner::after': {
        borderColor: token.colorPrimary
      }
    },
    quizTitle: {
      fontSize: '32px !important',
      textAlign: 'left'
    },
    questionWrapper: {
      minWidth: 520,
      maxWidth: 520,
      width: '100%'
    },
    questionAnswerWrapper: {
      minWidth: 520,
      width: '100%'
    },
    card: {
      '.ant-card-body': {
        display: 'flex',
        justifyContent: 'center',
        padding: 96
      }
    },
    languageSwitcher: {
      height: 'fit-content'
    },
    imagePreview: {
      borderRadius: 8,
      objectFit: 'cover',
      objectPosition: 'top',
      width: '220px !important',
      height: '120px !important'
    },
    imagePreviewMask: {
      borderRadius: '8px !important'
    }
  })
)
